export default {"src":"/newStatic/_next/static/media/youtube.382fb0a7.svg","height":16,"width":20};